module.exports = __webpack_public_path__ + "img/Big.7093ae52.svg";